// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"DashInfo_mainContainer__3TNsC"};